import { keepPreviousData, useQuery } from '@tanstack/vue-query';
import { type MaybeRefOrGetter } from 'vue';

import { keys } from '../keys';

export const useSupportGrantedAccounts = (name: MaybeRefOrGetter<string | undefined>) => useQuery({
  ...keys.accounts.supportGranted(name),
  placeholderData: keepPreviousData,
});
